import {CategoryHeader} from "./CategoryHeader";
import {useEffect, useState} from "react";
import {getAlternateMedicineNames} from "../Utils/api";
import {Col, Row} from "antd";
import {EntityList} from "./EntityList";

export const AlternateMedicine = ({ total }) => {

  const [drugsData, setDrugsData] = useState([])

  useEffect(() => {
    getAlternateMedicineNames()
      .then(r => setDrugsData(r.data))
  }, [])

  return(
    <>
      <CategoryHeader name="Alternate Medicine" total={total} />
      <br />
      <Row gutter={[20, 20]}>
        {Object.keys(drugsData).map((v, i) => <Col key={i} lg={12} xs={24}>
          <EntityList entityType="alternateMedicine" data={drugsData[v]} heading={v} />
        </Col>)}
      </Row>
    </>
  )
}